import { ArpMediaDraft, PaginatedResponse } from '@arpeggi/shared'
import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  useMutation,
  useQuery,
  UseQueryOptions
} from 'react-query'
import { queryClient } from '../../features/react-query-provider/ReactQueryClientProvider'
import {
  CreateDraftDto,
  GetDraftsParams,
  UpdateDraftDto,
  useArpDraftsAPI
} from '../api/v2/ArpDraftsAPI'
import { getNextPage, getPreviousPage } from './common'

export const useDrafts = (
  params?: GetDraftsParams,
  options?: UseInfiniteQueryOptions<PaginatedResponse<ArpMediaDraft>>
) => {
  const { getDrafts } = useArpDraftsAPI()

  return useInfiniteQuery(
    ['drafts', params],
    ({ pageParam = params?.page || 1 }) => getDrafts({ ...params, page: pageParam }),
    {
      getPreviousPageParam: (firstPage) => getPreviousPage(firstPage),
      getNextPageParam: (lastPage) => getNextPage(lastPage),
      ...options
    }
  )
}

export const useCreateDraft = () => {
  const { createDraft } = useArpDraftsAPI()

  return useMutation((dto: CreateDraftDto) => createDraft(dto), {
    onSuccess: () => {
      queryClient.invalidateQueries(['drafts'])
    }
  })
}

export const useUpdateDraft = () => {
  const { updateDraft } = useArpDraftsAPI()

  return useMutation(({ id, dto }: { id: number; dto: UpdateDraftDto }) => updateDraft(id, dto), {
    onSuccess: () => {
      queryClient.invalidateQueries(['drafts'])
    }
  })
}

export const useDraftShareCode = (id: number, options?: UseQueryOptions<{ shareCode: string }>) => {
  const { getDraftShareCode } = useArpDraftsAPI()

  return useQuery(['draft-share-code', id], () => getDraftShareCode(id), options)
}
